import React from "react"
import MobileNav from "../navbar/mobile-nav"
import DesktopNav from "../navbar/desktop-nav"

import "./layout.scss"

const Layout = ({ children, darkLogo }) => {
  return (
    <>
      <DesktopNav darkLogo={darkLogo} />
      {children}
      <MobileNav />
    </>
  )
}

export default Layout
